<template>
  <div
    class="bg-full vw-100 vh-100 flex-column d-flex justify-content-center align-items-center"
  >
    <div class="w-30 d-flex justify-content-center align-items-center mb-4">
      <img class="ef-logo mr-2" src="../assets/images/elitefit-logo-white.png">
      <span class="font-40 font-weight-300 text-white cursor-pointer">ELITEFIT.AI</span>
    </div>
    <div class="max-w-xl w-30">
      <div class="h-auto d-flex flex-column justify-content-center align-items-center p-3 bg-black">
        <b-form-input
            type="text"
            class="m-2 p-2 form-input font-16 line-height-24 font-weight-500"
            placeholder="Email"
            v-model="email"
        ></b-form-input>
        <b-form-input
            type="password"
            class="mx-2 p-2 mb-4 form-input font-16 line-height-24 font-weight-500"
            placeholder="Password"
            v-model="password"
        >
        </b-form-input>
        <span class="text-danger my-2">{{error}}</span>
        <div
            class="submit-button w-100 text-white font-weight-bold px-4 py-2 text-center bg-green mb-4 cursor-pointer"
            @click="login()"
        >
          SIGN IN
        </div>
      </div>
      <div class="text-right mt-1">
        <span class="p-1 small bg-black text-white w-100">{{ loginTo }}</span>
      </div>
    </div>

  </div>
</template>

<script>
import {createNamespacedHelpers} from "vuex"
const {mapState, mapActions } = createNamespacedHelpers("b2bClient")
export default {
  name: "SignInView",
  components: {},
  data(){
    return {
      email: null,
      password: null,
      error: null,
      loginTo: (this.$route.params.loginTo ?? 'ActiveHealth')
    }
  },
  computed:{
    ...mapState(['isAnonymous', 'successLogin', 'apiError'])
  },
  methods:{
    ...mapActions(['loginProcess']),
    async login(){
      this.error = null;
      if(!this.email){
        this.error= "please enter the email address."
        return;
      }
      if(!this.password){
        this.error= "please enter the password."
        return;
      }
      await this.loginProcess({email: this.email, password: this.password})
      if(this.successLogin){
        this.$router.push({name: 'intro-page'})
      }
      else{
        this.error= this.apiError
      }
    },
    redirectToSignUp(){
      this.$router.push({name: 'sign-up' , params:{tenant: this.$route.params.tenant}})
    },
    forgotPassword(){
      this.$router.push({name: 'forgot-password'})
    }
  },
  mounted() {
    localStorage.setItem('ssgLoginFrom', this.loginTo);
  }
};
</script>
<style scoped>
.bg-full {
  background-image: url("../assets/images/sign-in-background.webp");
}
.ef-logo {
  height: 60px;
  width: auto;
}
</style>
